document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collectio_hero_list_main').forEach(function(collcard) {
    const swiperEl = collcard.querySelector('.collectio_hero_list_swiper');
    if (!swiperEl) return;
    const prevBtn = collcard.querySelector('.collectio_hero_list_button_prev');
    const nextBtn = collcard.querySelector('.collectio_hero_list_button_next');
    const pagination = collcard.querySelector('.collectio_hero_list_pagination');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: pagination,
        type: "progressbar",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function () {
            checkScrollable(this);
        },
        resize: function () {
            checkScrollable(this);
        },
     },
    });
    function checkScrollable(swiperInstance) {
        const mainwrapp = collcard.querySelector('.collectio_hero_list_content');
        const wrapper = swiperInstance.wrapperEl;
        const container = swiperInstance.el;
        if (wrapper.scrollWidth > container.clientWidth) {
            mainwrapp.classList.add("collectio_hero_list_scrollable");
            mainwrapp.classList.remove("collectio_hero_list_not_scrollable");
        } else {
            mainwrapp.classList.remove("collectio_hero_list_scrollable");
            mainwrapp.classList.add("collectio_hero_list_not_scrollable");
        }
    }
  });
});